<div class="general-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12 general-page__content">
                <div class="general-card">
                    <div class="general-card__header">
                        <img src="/assets/images/Group 9.svg" alt="" />
                        <div class="general-card__header-headline">
                            <h2>Bine ați venit!</h2>
                            <h4>Plăți - Evidență</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="section m-0">
                    <div class="section-top">
                        <h3 class="section-title">Plăți</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row p-3">
                        <div class="col-md mb-2">
                            <h4><strong>Filtre</strong></h4>
                            <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Cetățean</mat-label>
                                            <input matInput type="text" formControlName="cetatean" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Metoda de plată</mat-label>
                                            <mat-select formControlName="metoda_plata">
                                                <mat-option *ngFor="let param of metodePlata" [value]="param.id">
                                                    {{ param.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>CNP/CUI Cetățean</mat-label>
                                            <input matInput type="number" formControlName="cnp_cui" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 d-flex justify-content-start">
                                        <button type="button" class="btn btn-light action-button w-100"
                                            [popover]="popTemplate" [adaptivePosition]="true" container="body"
                                            boundariesElement="viewport" placement="right">
                                            <div
                                                class="d-flex justify-content-between align-items-center w-100 flex-wrap gap-1">
                                                <div class="d-flex align-items-center">
                                                    <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                                    <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{
                                                        selectedEndDate |
                                                        date :
                                                        "dd.MM.yyyy"
                                                        }}
                                                    </span>
                                                </div>
                                                <button type="button" class="btn border"
                                                    [ngClass]="{'btn-success': isActive, 'btn-warning': !isActive}">
                                                    <span *ngIf="isActive">Activ</span>
                                                    <span *ngIf="!isActive">Inactiv</span>
                                                </button>
                                            </div>
                                        </button>

                                        <!-- Popover Template below-->
                                        <ng-template #popTemplate>
                                            <div class="popover">
                                                <div class="row">
                                                    <div class="col d-flex justify-content-between">
                                                        <h2>Selectați intervalul</h2>
                                                        <div class="d-flex gap-1">
                                                            <button type="button" style="height: 40px; width: 100px"
                                                                class="btn border"
                                                                [ngClass]="{'btn-success': isActive, 'btn-warning': !isActive}"
                                                                (click)="toggleIsActive()">
                                                                <span *ngIf="isActive"
                                                                    class="active-btn-text">ACTIV</span>
                                                                <span *ngIf="!isActive"
                                                                    class="active-btn-text">INACTIV</span>
                                                            </button>
                                                            <button style="height: 40px; width: 100px"
                                                                class="btn btn-light close-btn"
                                                                (click)="closePopover()">
                                                                <img src="assets/icons/close.svg" alt="Închide"
                                                                    style="height: 20px; width: 20px" />
                                                                <span class="close-text">ÎNCHIDE</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row mt-2 mb-2">
                                                    <div class="col d-flex gap-1 justify-content-between">
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'last_0_days'
                                                            " (click)="setLastXDays(0)">
                                                            <span>ZIUA CURENTĂ</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'last_1_days'
                                                            " (click)="setLastXDays(1)">
                                                            <span>ZIUA ANTERIOARĂ</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'last_7_days'
                                                            " (click)="setLastXDays(7)">
                                                            <span>ULTIMELE 7 ZILE</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'current_year'
                                                            " (click)="setYear(0)">
                                                            <span>ANUL CURENT</span>
                                                        </button>
                                                        <button type="button" class="action-button" [class.selected]="
                                                            selectedFilteringButton === 'all_years'
                                                            " (click)="setAllYears()">
                                                            <span>TOATĂ PERIOADA</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="datepicker-container">
                                                    <div class="col">
                                                        <div class="datepicker-header">
                                                            <div class="text">DE LA:</div>
                                                            <div class="date">
                                                                {{ selectedStartDate | date : "mediumDate" }}
                                                            </div>
                                                        </div>
                                                        <mat-card>
                                                            <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                                [(selected)]="selectedStartDate" [maxDate]="today"
                                                                [maxDate]="selectedEndDate"></mat-calendar>
                                                        </mat-card>
                                                    </div>
                                                    <div class="col">
                                                        <div class="datepicker-header">
                                                            <div class="text">PANA LA:</div>
                                                            <div class="date">
                                                                {{ selectedEndDate | date : "mediumDate" }}
                                                            </div>
                                                        </div>
                                                        <mat-card>
                                                            <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                                [maxDate]="today"></mat-calendar>
                                                        </mat-card>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-start my-md-0 my-2">
                                        <button type="submit"
                                            class="col-md-6 d-flex justify-content-center align-items-center action-button w-100"
                                            [disabled]="isLoading">
                                            <ng-container *ngIf="!isLoading">
                                                <i class="fa-solid fa-search me-2"></i>
                                                <span>Caută</span>
                                            </ng-container>

                                            <ng-container *ngIf="isLoading">
                                                <mat-spinner diameter="30"></mat-spinner>
                                            </ng-container>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-md mb-2">
                            <div class="">
                                <table class="table-payment w-100">
                                    <tbody>
                                        <tr class="border-bottom">
                                            <td width="40%" class="text-end p-2">
                                                <strong>#</strong>
                                            </td>
                                            <td class="text-start p-2">
                                                <strong>Încasat</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-end p-2">
                                                <strong>Total</strong>
                                            </td>
                                            <td class="text-start p-2 value">{{totalIncasat}} RON</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>